// extracted by mini-css-extract-plugin
export default {"titleWithCoverage":"skills_chart_modal-module___titleWithCoverage___a34f46e9","modal":"skills_chart_modal-module___modal___da333678"};